import { Button } from '@toolbox/components';
import { useCloseWidget, useFlags, useLeadData, useWidgetContext } from '@widget/core';
import { CloseIcon } from '@toolbox/components/Icon/icons/CloseIcon';
import { pushGAEvent } from '@widget/analytics';
import { getAnalyticsFields } from '@widget/utils/getAnalyticsFields';

import type { LeadData } from '@widget/core';
import type { ButtonProps } from '@toolbox/components';
import type { ReactFCWithChildren } from '@widget/types/ReactFCWithChildren';

type CloseButtonProps = ButtonProps & {
  text?: string;
};

export const CloseButton: ReactFCWithChildren<CloseButtonProps> = ({
  text = 'SCHLIESSEN',
  ...props
}) => {
  const {
    close,
    reset,
    enableReset,
    cancelIcon,
    transactionId,
    widgetId,
    analyticsMap,
    stepIndex,
    activeId,
    prevStepId,
    getFormData,
  } = useWidgetContext();
  const { setIsOpenModal, isThankYouPageShown } = useCloseWidget();
  const { enableExitPopup } = useFlags();
  const { setLeadData } = useLeadData();

  const Icon =
    typeof cancelIcon === 'object' && cancelIcon?.filename ? (
      <img src={cancelIcon?.filename} alt={cancelIcon?.alt || ''} />
    ) : (
      <CloseIcon css={{ width: 13 }} />
    );

  const closeWidget = (): void => {
    if (!isThankYouPageShown && enableExitPopup) {
      setIsOpenModal(true);
    } else {
      setLeadData({} as LeadData);
      close();
    }
  };

  const resetWidget = (): void => {
    setLeadData({} as LeadData);
    reset();
  };

  const onClick = () => {
    pushGAEvent('step-click_to_close_widget', {
      ...getAnalyticsFields({ analyticsMap, source: getFormData() }),
      transactionId,
      widgetId,
      stepIndex,
      stepId: activeId,
      prevStepId,
    });

    enableReset ? resetWidget() : closeWidget();
  };

  return (
    <Button type="button" size={'medium'} variant={'tertiary'} onClick={onClick} {...props}>
      <span
        style={{
          verticalAlign:
            typeof cancelIcon === 'object' && cancelIcon?.filename ? 'text-bottom' : 'inherit',
        }}
      >
        {text}
      </span>{' '}
      {Icon}
    </Button>
  );
};
